import { curry, pipe, eq, negate, dropWhile, drop } from 'lodash/fp';
/**
 * Returns all elements from an array after an element passing equality test.
 *
 * @param {any} element - element to be tested
 *
 * @example
 * takeAllAfter(3, [1, 2, 3, 4, 5, 6])
 * // => [4, 5, 6]
 */

export default curry(function (element, data) {
  return pipe([dropWhile(negate(eq(element))), drop(1)])(data);
});